import { createApp } from 'vue';

import App from './App.vue';
import router from './router';
import core from './core';
import VueSimpleAlert from "vue3-simple-alert-next";
import naive from 'naive-ui';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import './style/custom.css';

import '@sweetalert2/themes/material-ui'; //theme of popups...
import Loader from './components/loader/Loader.vue';

import moment from 'moment';
import Axios from 'axios';

import UI from './ui';
import http from './composables/http';
import { createHead } from '@vueuse/head'

const app = createApp(App);
const head = createHead()

core.loadStorage();


app.config.globalProperties.$core = core;
app.config.globalProperties.$axios = Axios;
app.config.globalProperties.$ui = UI;
app.config.globalProperties.$http = http;

// Register components
app.use(VueSimpleAlert, { reverseButtons: true });
app.component('Loader', Loader); //Loader

app.use(naive);
app.use(router);

app.use(head)
 
app.mount('#app');


const $ = require('jquery');
window.$ = $;
window.$core = core;
window.$router = router;
window.$http = http;

Date.prototype.toJSON = function () { return moment(this).format() };// to fix json.stringfy(date)...

Date.prototype.toDateFormat = function (format = 'll') { return moment(this).format(format) };

